import { apiClient } from '../api';
import { clientLogger } from '../utils/client-logger';

const SKIP_STORAGE_KEY = 'tap-connect.playerPrefetchSkipped.v1';

let cachedResult: { hasCredentials: boolean } | undefined;

const isPrefetchSkipped = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.sessionStorage.getItem(SKIP_STORAGE_KEY) === 'true';
};

export const getPlayerPrefetchResult = (): { hasCredentials: boolean } =>
  cachedResult ?? { hasCredentials: false };

export const markPlayerPrefetchSkipped = (): void => {
  cachedResult = { hasCredentials: false };
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(SKIP_STORAGE_KEY, 'true');
};

export const prefetchPlayerCredentials = async (
  player: string
): Promise<void> => {
  if (cachedResult) return;
  if (isPrefetchSkipped()) {
    cachedResult = { hasCredentials: false };
    return;
  }
  try {
    cachedResult = await apiClient.tapResearchPlayerLookup(player);
  } catch (error) {
    clientLogger.warn('Player credentials prefetch failed', { error });
    cachedResult = { hasCredentials: false };
  }
};
